import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input'];
  static values = { url: String };

  connect() {
    this.timeout = null;
    this.currentSearch = '';
  }

  search(event) {
    const searchTerm = event.target.value.trim();

    // Clear existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    // Set a new timeout for debouncing
    this.timeout = setTimeout(() => {
      this.performSearch(searchTerm);
    }, 300); // 300ms delay for debouncing
  }

  performSearch(searchTerm) {
    // Don't search if the term hasn't changed
    if (searchTerm === this.currentSearch) {
      return;
    }

    this.currentSearch = searchTerm;

    // Build the URL with search parameters
    const url = new URL(this.urlValue, window.location.origin);
    const currentParams = new URLSearchParams(window.location.search);

    // Preserve existing params (tab, virtual_classroom_id)
    currentParams.forEach((value, key) => {
      if (key !== 'search') {
        url.searchParams.append(key, value);
      }
    });

    // Add or update search param
    if (searchTerm.length > 0) {
      url.searchParams.set('search', searchTerm);
    }

    // Fetch filtered results
    fetch(url, {
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.text())
      .then((html) => {
        // Parse the response and update only the student cards
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCards = doc.querySelector('.student-cards-container');
        const currentCards = document.querySelector('.student-cards-container');

        if (newCards && currentCards) {
          // Add fade effect
          currentCards.style.opacity = '0.5';

          setTimeout(() => {
            currentCards.innerHTML = newCards.innerHTML;
            currentCards.style.opacity = '1';
          }, 150);
        }

        // Update URL without page reload
        window.history.replaceState({}, '', url);
      })
      .catch((error) => {
        console.error('Search error:', error);
      });
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
